const dataMapAccordion = [
  {
    title: 'Lorem ipsum 1',
    mainId: 'main-id-',
    secondaryId: 'secondary-id-'
  },
  {
    title: 'Lorem ipsum 2',
    mainId: 'main-id-',
    secondaryId: 'secondary-id-'
  },
  {
    title: 'Lorem ipsum 3',
    mainId: 'main-id-',
    secondaryId: 'secondary-id-'
  }
];

const list = [
  { value: '1', text: 'Opción 1' },
  { value: '2', text: 'Opción 2' },
  { value: '3', text: 'Opción 3' }
];

const sexo = [
  { value: 'M', text: 'Femenino' },
  { value: 'H', text: 'Masculino' }
];

const discapacidad = [
  { value: 0, text: 'No aplica' },
  { value: 1, text: 'Menos del 33%' },
  { value: 2, text: 'Del 33%-65%' },
  { value: 3, text: 'Del 33%-65% con ayuda' },
  { value: 4, text: 'Más del 65%' }
];

const stateRelation = [
  { value: '1', text: 'Soltero, Viudo, Divorciado o Separado Legalmente' },
  { value: '2', text: 'Casado y no separado con cónyuge a cargo' },
  { value: '3', text: 'Otras situaciones, o no desea manifestarla' }
];

const list2 = [
  { value: '1', text: 'Opción 1' },
  { value: '2', text: 'Opción 2' },
  { value: '3', text: 'Opción 3' },
  { value: 'Otros', text: 'Otros' }
];
const list3 = [
  {
    name: 'Audiencias generales',
    pdf: 'http://www.marca.es',
    xls: 'http://www.marca.es'
  },
  {
    name: 'Minuto a minuto',
    pdf: 'http://www.marca.es'
  },
  {
    name: 'Audiencias de Canarias',
    xls: 'http://www.marca.es'
  },
  {
    name: 'Minuto a minuto por regiones',
    pdf: 'http://www.marca.es',
    xls: 'http://www.marca.es'
  },
  {
    name: 'Informe de géneros',
    pdf: 'http://www.marca.es',
    xls: 'http://www.marca.es'
  }
];

const list4 = [
  {
    text: 'Audiencias generales',
    urlpdf: 'pdf',
    urlxls: 'xls',
    urllink: 'link'
  },
  {
    text: 'Minuto a minuto',
    urlpdf: 'pdf',
    urllink: 'link'
  },
  {
    text: 'Audiencias de Canarias',
    urllink: 'link'
  }
];

const list5 = [
  {
    text: '05_septiembre.pdf',
    href: 'http://www.marca.es'
  },
  {
    text: '05_septiembre.pdf',
    href: 'http://www.marca.es'
  },
  {
    text: '05_septiembre.pdf',
    href: 'http://www.marca.es'
  },
  {
    text: '05_septiembre.pdf',
    href: 'http://www.marca.es'
  },
  {
    text: '05_septiembre.pdf',
    href: 'http://www.marca.es'
  },
  {
    text: '05_septiembre.pdf',
    href: 'http://www.marca.es'
  },
  {
    text: '05_septiembre.pdf',
    href: 'http://www.marca.es'
  },
  {
    text: '05_septiembre.pdf',
    href: 'http://www.marca.es'
  }
];

const list6 = [
  {
    text: '05_septiembre.pdf',
    href: 'http://www.marca.es'
  }
];

export {
  dataMapAccordion,
  list,
  list2,
  list3,
  list4,
  list5,
  list6,
  sexo,
  stateRelation,
  discapacidad
};
